"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaParentBlockIdentifierToJSON = exports.RosettaParentBlockIdentifierFromJSONTyped = exports.RosettaParentBlockIdentifierFromJSON = void 0;
function RosettaParentBlockIdentifierFromJSON(json) {
    return RosettaParentBlockIdentifierFromJSONTyped(json, false);
}
exports.RosettaParentBlockIdentifierFromJSON = RosettaParentBlockIdentifierFromJSON;
function RosettaParentBlockIdentifierFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'index': json['index'],
        'hash': json['hash'],
    };
}
exports.RosettaParentBlockIdentifierFromJSONTyped = RosettaParentBlockIdentifierFromJSONTyped;
function RosettaParentBlockIdentifierToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'index': value.index,
        'hash': value.hash,
    };
}
exports.RosettaParentBlockIdentifierToJSON = RosettaParentBlockIdentifierToJSON;
//# sourceMappingURL=RosettaParentBlockIdentifier.js.map